<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
</script>

<template>
  <AuSkeletonWrapper class="max-w-screen-au relative mx-auto my-8 flex flex-col flex-wrap gap-4 px-4 transition-all sm:flex-row sm:items-center sm:px-8">
    <AuSkeleton
      class="motion-safe:animate-fade-in-up"
      width="12%"
      height="42px"
    />
    <AuSkeleton
      class="motion-safe:animate-fade-in-up"
      width="10%"
      height="42px"
    />
    <AuSkeleton
      class="motion-safe:animate-fade-in-up"
      width="17%"
      height="42px"
    />
  </AuSkeletonWrapper>
</template>
